import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';
import { dataChartLogic } from './data_chart.logic';
import { DataChartActivityView } from './DataChartViews';

export const dataChartPlugin: ActivityPlugin<'data_chart'> = {
  ...dataChartLogic,
  displayName: GAME_MODE_CATALOG.data_chart.displayName,
  icon: GAME_MODE_CATALOG.data_chart.icon,
  HostView: DataChartActivityView,
  StudentView: DataChartActivityView,
  ProjectorView: DataChartActivityView,
};

export { demoDataChartPayload } from './data_chart.logic';
